module.exports = __webpack_public_path__ + "static/img/04.eca42ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour1/04.jpg
// module id = Z7sf
// module chunks = 0